import React, { FC, ReactNode, useState } from "react";
import styles from "./TabComponent.module.scss";

export interface TabComponentProps extends React.HTMLAttributes<HTMLDivElement> {
  tabs: {
    title: string;
    content: ReactNode
  }[],
  defaultTab?: number
}

export const TabComponent: FC<TabComponentProps> = ({
  tabs,
  defaultTab=0,
  className,
  ...props
}) => {
  const [activeTabId, setActiveTabId] = useState(defaultTab)
  
  return (
    <div className={`${styles.tabsComponent} ${className}`} {...props}>
      <div className={styles.tabs}>
        {tabs.map((tab, index) => (
          <button
            key={index}
            onClick={() => setActiveTabId(index)}
            className={`${styles.tab} ${index === activeTabId && styles.activeTab}`}>
            {tab.title}
          </button>
        ))} 
      </div>
      <div className={styles.tabsContent}>
        {tabs[activeTabId].content}
      </div>
    </div>
  )
}